import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect, useRef } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { WebrtcState } from 'sdk';

import { useSDK } from '../../app';
import { useUIState } from '../../app/App';
import { styled } from '../../styled';
import { VIDEO_CALLS_ARE_SUPPORTED } from '../../utils/isVideoCallsSupported';
import { ChatForm } from '../forms/chatForm';
import { VideoPanel } from '../videoPanel';
import { ChatMessagesList } from './chatMessagesList';
import { ConnectionCorrupted } from './connectionCorrupted';
import { NewQuestionButton } from './newQuestionButton';

const newQuestion = defineMessage({
	id: 'chat.buttons.newQuestion',
	defaultMessage: 'Новый вопрос',
});

const Component = observer(({ className }: { className: string }): ReactElement => {
	const rootStore = useSDK();
	const { videoCallsStore, uiStateStore, connectionManager } = useSDK();
	const scrollWrapper = useRef<HTMLDivElement>(null);
	const intl = useIntl();
	const { scrollStore, clientViewport } = useUIState();

	useEffect(() => {
		if (scrollWrapper.current) {
			scrollStore.setScrollWrapper(scrollWrapper.current);
		}
	}, [scrollStore]);

	const onNewQuestion = async (): Promise<void> => {
		const canSendNewQuestion = await rootStore.existingConversationIsLast();
		if (!canSendNewQuestion) {
			rootStore.updateConversation();
		}
		uiStateStore.resetState();
	};

	return (
		<div className={className}>
			{((VIDEO_CALLS_ARE_SUPPORTED && videoCallsStore.state === WebrtcState.connected) ||
				videoCallsStore.state === WebrtcState.ringing) &&
				clientViewport.width < 1000 && <VideoPanel />}
			{connectionManager.connectionCorrupted && <ConnectionCorrupted />}
			<ChatMessagesList />
			{uiStateStore.showRestartButton && (
				<NewQuestionButton onClick={onNewQuestion}>{intl.formatMessage(newQuestion)}</NewQuestionButton>
			)}
			<ChatForm />
		</div>
	);
});

const ChatContainerInner = styled(Component)(css`
	display: flex;
	flex-flow: column;
	height: 100%;
	overflow: visible;
`);

export { ChatContainerInner };
